import ProductPlan from "../ProductPlan";
import { en, nl } from "chartjs-graph/translations/product-plans/car_rental";

export default new ProductPlan({ en, nl });
